module.exports = __webpack_public_path__ + "img/logo.193ff77f.png";